import { StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { Theme, ThemedText, ThemedView } from '@app/theme'
import { useTheme } from '@shopify/restyle'
import SystemWarning from '@app/assets/svg/SystemWarning'
import Button from '@app/sharedComponents/Button/Button'
import { ThemedTouchableOpacity } from '@app/theme/Components'

const MandateCancelled = ({ onRetry , onContactUsPressed , isLoading }: { onRetry: () => void , onContactUsPressed : () => void , isLoading : boolean }) => {

    const { colors } = useTheme<Theme>()
    return (
        <ThemedView padding='lg' alignItems='center' justifyContent='center'>
            <SystemWarning color={colors['icon-error']} size={48} />
            <ThemedText mt='xl' mb='xs' variant='h5b' color='text-primary'>
                Mandate setup canceled
            </ThemedText>
            <ThemedText mb='md' color='text-secondary' textAlign='center' variant='b3r'>
                A mandate setup is required for the completion of your loan application
            </ThemedText>
            <Button
                label='Retry mandate setup'
                type='OUTLINED'
                handlePress={onRetry}
                buttonLoader={isLoading}
            />
            <ThemedView flexDirection='row' alignItems='center' justifyContent='center' mt='xl'>
                <ThemedText mr='sm' variant='b3r'>Need help?</ThemedText>
                <ThemedTouchableOpacity onPress={onContactUsPressed}>
                    <ThemedText color='text-action-primary' variant='b3b'>
                        Contact us
                    </ThemedText>
                </ThemedTouchableOpacity>
            </ThemedView>
        </ThemedView>
    )
}

export default MandateCancelled

const styles = StyleSheet.create({})